var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLoanClosure = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 20,
  viewBox: "0 0 17 20",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_loan_closure",
  transform: "translate(-6721 -13632)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_12",
  "data-name": "Subtraction 12",
  d: "M7.948,18H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H13a1,1,0,0,1,1,1v9.528a5.18,5.18,0,0,0-1-.2V1H1V17H7.528a5.17,5.17,0,0,0,.419,1Z",
  transform: "translate(6721 13632)",
  fill: "#248e12"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_266",
  "data-name": "Rectangle 266",
  transform: "translate(6729 13643)",
  fill: "none",
  stroke: "#248e12",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 9,
  rx: 4.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 8,
  height: 8,
  rx: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_267",
  "data-name": "Rectangle 267",
  width: 4,
  height: 1,
  rx: 0.5,
  transform: "translate(6728 13638)",
  fill: "#248e12"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_270",
  "data-name": "Rectangle 270",
  width: 4,
  height: 1,
  rx: 0.5,
  transform: "translate(6728 13635)",
  fill: "#248e12"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_268",
  "data-name": "Rectangle 268",
  width: 8,
  height: 1,
  rx: 0.5,
  transform: "translate(6724 13641)",
  fill: "#248e12"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_269",
  "data-name": "Rectangle 269",
  width: 4,
  height: 1,
  rx: 0.5,
  transform: "translate(6724 13644)",
  fill: "#248e12"
}), /*#__PURE__*/React.createElement("path", {
  id: "_",
  "data-name": "$",
  d: "M1.917-6.132a.5.5,0,0,0-.14-.365,1.225,1.225,0,0,0-.467-.26A3.673,3.673,0,0,1,.8-6.967,1.034,1.034,0,0,1,.2-7.93a.99.99,0,0,1,.262-.711,1.116,1.116,0,0,1,.711-.329v-.566h.415v.571a1.027,1.027,0,0,1,.7.38,1.311,1.311,0,0,1,.246.825H1.9a.818.818,0,0,0-.146-.515.478.478,0,0,0-.4-.19.538.538,0,0,0-.387.142.512.512,0,0,0-.14.386.484.484,0,0,0,.139.362,1.35,1.35,0,0,0,.47.258,3.98,3.98,0,0,1,.521.226,1.332,1.332,0,0,1,.317.237.943.943,0,0,1,.2.306,1.085,1.085,0,0,1,.07.407.969.969,0,0,1-.267.711,1.181,1.181,0,0,1-.748.322V-4.6H1.118v-.5a1.185,1.185,0,0,1-.789-.368,1.2,1.2,0,0,1-.276-.825h.63a.72.72,0,0,0,.165.507.6.6,0,0,0,.466.178.64.64,0,0,0,.45-.143.491.491,0,0,0,.154-.382Z",
  transform: "translate(6723.452 13643.789)",
  fill: "#248e12",
  stroke: "#248e12",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "autorenew_24dp_5F6368_FILL0_wght400_GRAD0_opsz24",
  d: "M160.45-919.138s1.9-.1,2.784-.1h.069l-.633-.633.554-.554,1.583,1.583-1.583,1.583-.554-.554.633-.633h-.069c-.66,0-2.757.1-2.757.1Z",
  transform: "matrix(-0.035, 0.999, -0.999, -0.035, 5820.981, 13453.018)",
  fill: "#248e12",
  stroke: "#248e12",
  strokeWidth: 0.2
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLoanClosure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_loan_closure.27ea8fdc34c79b9fcccb3abea7e2f3c4.svg";